import { Stack, Typography } from '@mui/material'

import {
  Maybe,
  PaymentDetailFragment,
  PaymentMethod,
} from '@/clients/utoniq-core/schema'
import { StorageImage, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { generateCreditCardLogoPath } from '@/core/creditCard'

type PaymentInfoCellProps = {
  paymentSource?: Maybe<PaymentDetailFragment>
  paymentMethod?: PaymentMethod
}
export const PaymentInfoCell: Cell<PaymentInfoCellProps> = ({
  paymentSource,
  paymentMethod,
}) => {
  const { t } = useTranslation('lotteryConfirmation')

  switch (paymentMethod) {
    case PaymentMethod.CreditCard:
      return (
        <CellFrame sx={{ pb: 5 }}>
          <Stack sx={{ px: 2, py: 1, bgcolor: 'grey.50' }}>
            <Typography variant="h5" color="text.secondary">
              {t('paymentInfo', '支払い情報')}
            </Typography>
          </Stack>
          <Stack sx={{ pt: 3 }}>
            <Typography variant="subtitle1" color="text.secondary">
              {t('creditCardInfo', 'クレジットカード情報')}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={3}>
              <StorageImage
                width={40}
                height={32}
                src={generateCreditCardLogoPath(paymentSource?.brand)}
                target="common"
              />
              <Typography variant="body2">
                {t('last4Digit', { number: paymentSource?.last4 })}
              </Typography>
            </Stack>
          </Stack>
        </CellFrame>
      )
    case PaymentMethod.Konbini:
      return (
        <CellFrame sx={{ pb: 5 }}>
          <Stack sx={{ px: 2, py: 1, bgcolor: 'grey.50' }}>
            <Typography variant="h5" color="text.secondary">
              {t('paymentInfo', '支払い情報')}
            </Typography>
          </Stack>
          <Stack sx={{ pt: 3 }}>
            <Typography variant="h5">
              {t('convenienceStore', 'コンビニ決済')}
            </Typography>
            <Typography variant="caption" sx={{ display: 'block', mt: 2 }}>
              {t(
                'convenienceStoreDesc',
                'ファミリーマート、ローソン、ミニストップ、セイコーマートに対応しています。'
              )}
            </Typography>
          </Stack>
        </CellFrame>
      )
    default:
      return null
  }
}
